import React from "react";
import EmptyState from "../../elements/EmptyState";
import { userDetails } from '../../../utils';
import CreateEditEmergencyContact from "./CreateEditEmergencyContact";
import ModalDialog from "../../layouts/ModalDialog";

const Detail = ({ label, value }) => (
  <div className="w-full p-2">
    <p className="text-xs font-medium text-vcm-dark-gray">
      {label}
    </p>
    <p className="mt-1 text-sm font-medium text-gray-900">
      {value || <span className='text-gray-400'>Not provided</span>}
    </p>
  </div>
);

const ContactCard = ({ title, contact }) => (
  <article className="rounded-xl border border-gray-200 p-2">
    <h3 className="font-space-grotesk text-base font-semibold text-gray-900">
      {title}
    </h3>
    <div className="mt-5 grid grid-cols-1 gap-x-3 gap-y-3 sm:grid-cols-2">
      <Detail label="Full name" value={contact?.name} />
      <Detail label="Phone number" value={contact?.phone} />
      <Detail label="Email address" value={contact?.email} />
      <Detail label="Address" value={contact?.address} />
    </div>
  </article>
);

const StaffEmergencyContacts = ({ staff, reload }) => {
  const hasContacts = staff?.nextOfKin || staff?.emergencyContact;

  const currentStaffLoggedIn = staff?._id === userDetails()?.staffMemberProfile;
  const [settingEmergencyContact, setSettingEmergencyContact] = React.useState(false);
  const [settingNextOfKin, setSettingNextOfKin] = React.useState(false);

  return (
    <>
      <section className="overflow-hidden ">
        <div className="border-b border-gray-100 px-2 py-2 flex items-start justify-between gap-2">
          <div className="w-8/12">
            <h2 className="font-space-grotesk text-lg font-semibold text-gray-900">
              Employee contacts
            </h2>
            <p className="mt-1 text-sm text-vcm-dark-gray">
              The persons to contact {currentStaffLoggedIn ? "on your behalf" : "for this staff member"} in case of an emergency.
            </p>
          </div>

          {currentStaffLoggedIn && !hasContacts && (
            <button onClick={()=>{setSettingEmergencyContact(true)}} className="text-xs font-semibold font-space-grotesk text-gray-600 rounded-lg bg-gray-200 hover:bg-gray-300 transition duration-200 px-4 py-3">
              Add Emergency Contact
            </button>
          )}

          {currentStaffLoggedIn && staff?.emergencyContact && !staff?.nextOfKin && (
            <button onClick={()=>{setSettingNextOfKin(true)}} className="text-xs font-semibold font-space-grotesk text-gray-600 rounded-lg bg-gray-200 hover:bg-gray-300 transition duration-200 px-4 py-3">
              Add Next of Kin
            </button>
          )}
          
        </div>
        {hasContacts ? (
          <div className="grid grid-cols-1 gap-4 p-5 xl:grid-cols-2">
            {staff?.nextOfKin && (
              <ContactCard title="Next of kin" contact={staff.nextOfKin} />
            )}
            {staff?.emergencyContact && (
              <ContactCard
                title="Emergency contact"
                contact={staff.emergencyContact}
              />
            )}
          </div>
        ) : (
          <EmptyState
            emptyStateTitle="No emergency contacts available"
            emptyStateText="Emergency contact information will appear here when it is added."
          />
        
        )}
      </section>

      <ModalDialog
        shown={settingEmergencyContact} 
        closeFunction={()=>{setSettingEmergencyContact(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle='Set emergency contact'
        maxWidthClass='max-w-lg'
        hideActions={true}
      >
        <CreateEditEmergencyContact type="emergency" staff={staff} close={()=>{setSettingEmergencyContact(false)}} reload={reload} />
      </ModalDialog>

      <ModalDialog
        shown={settingNextOfKin} 
        closeFunction={()=>{setSettingNextOfKin(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle='Set next of kin'
        maxWidthClass='max-w-lg'
        hideActions={true}
      >
        <CreateEditEmergencyContact type="nok" staff={staff} close={()=>{setSettingNextOfKin(false)}} reload={reload} />
      </ModalDialog>
    </>
  );
};

export default StaffEmergencyContacts;
